import React from "react";
import { doctorRoleGroupsText, getAppointmentDoctorRoleGroups } from '../customer-services/customerServiceDoctorRoleHelpers';

const muted = { color: "#8c8c8c" };
const joinNames = (arr) => (arr || []).map(x => x?.full_name).filter(Boolean).join(", ");

const AppointmentServicesCell = ({ services = [] }) => {
    if (!services?.length) return <span style={muted}>—</span>;

    return (
        <div style={{ lineHeight: 1.35 }}>
            {services.map((s) => {
                const cs = s?.customer_service;
                const sv = cs?.service;

                const title = sv?.name || `DV#${cs?.id || s?.customer_service_id || s?.id}`;

                const doctorsText = doctorRoleGroupsText(getAppointmentDoctorRoleGroups(s));
                const assistantsText = joinNames(s?.assistants);

                return (
                    <div key={s?.id} style={{ marginBottom: 8 }}>
                        <div style={{ fontWeight: 600, color: "#222" }}>
                            {title}
                        </div>

                        {doctorsText ? (
                            <div style={muted}>
                                <span style={{ color: "#222" }}>{doctorsText}</span>
                            </div>
                        ) : null}

                        {assistantsText ? (
                            <div style={muted}>
                                PT: <span style={{ color: "#222" }}>{assistantsText}</span>
                            </div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
};

export default AppointmentServicesCell;
